import { 
  LucideIcon,
  Briefcase, Frown, Lightbulb, User, Users, Search, Coffee, FileText, Zap, Mail, 
  UserMinus, Ghost, BatteryLow, FileQuestion, Inbox, UserCheck, Activity, RefreshCw, 
  Handshake, Bot, UserCog, Presentation, BookOpen, Award, PenTool, DollarSign, 
  Gavel, Heart, Target, BatteryCharging, Sprout, ArrowRightLeft, Layers, 
  FileSignature, XCircle, HelpCircle, Plus, Edit2, Trash2, MoreVertical,
  Rocket, Star, Crown, Flame, Compass
} from "lucide-react";

export const ICON_MAP: Record<string, LucideIcon> = {
  Briefcase,
  Frown,
  Lightbulb,
  User,
  Users,
  Search,
  Coffee,
  FileText,
  Zap,
  Mail,
  UserMinus,
  Ghost,
  BatteryLow,
  FileQuestion,
  Inbox,
  UserCheck,
  Activity,
  RefreshCw,
  Handshake,
  Bot,
  UserCog,
  Presentation,
  BookOpen,
  Award,
  PenTool,
  DollarSign,
  Gavel,
  Heart,
  Target,
  BatteryCharging,
  Sprout,
  ArrowRightLeft,
  Layers,
  FileSignature,
  XCircle,
  HelpCircle,
  Plus,
  Edit2,
  Trash2,
  MoreVertical,
  Rocket,
  Star,
  Crown,
  Flame,
  Compass,
};

export function getIcon(iconName: string | null | undefined): LucideIcon {
  if (!iconName) return HelpCircle;
  return ICON_MAP[iconName] || HelpCircle;
}

export const AVAILABLE_ICONS = Object.keys(ICON_MAP).filter(
  name => !['Plus', 'Edit2', 'Trash2', 'MoreVertical', 'HelpCircle'].includes(name)
);
